import { useRef, useState, useEffect } from 'react';

import { PlayIcon } from './SvgComponents/PlayIcon';
import { PauseIcon } from './SvgComponents/PauseIcon';
import { NextIcon } from './SvgComponents/NextIcon';
import { PrevIcon } from './SvgComponents/PrevIcon';
import { VolumeIcon } from './SvgComponents/VolumeIcon';
import { MuteIcon } from './SvgComponents/MuteIcon';

export const MediaPlayer = () => {
  const audioPlayer = useRef();
  const progressBar = useRef();
  const [isPlaying, setPlaying] = useState(false);
  const [isMuted, setMuted] = useState(false);
  const [currentSound, setCurrentSound] = useState(0);

  const playList = [
    'hedwigstheme',
    'lilytheme',
    'fawkesthephoenix',
    'theroomofrequirement',
    'awindowtothepast',
    'leavinghogwarts',
    'harrywondrousworld',
  ];

  useEffect(() => {
    if (isPlaying) {
      audioPlayer.current.play();
    } else {
      audioPlayer.current.pause();
    }
  }, [isPlaying, currentSound]);

  const togglePlay = () => {
    setPlaying(!isPlaying);
  };

  const handleNextTrack = () => {
    const nextCount = currentSound + 1;
    setCurrentSound(nextCount > 6 ? 0 : nextCount);
    setPlaying(true);
  };

  const handlePreviousTrack = () => {
    const prevCount = currentSound - 1;
    setCurrentSound(prevCount < 0 ? 6 : prevCount);
    setPlaying(true);
  };

  const handleMute = () => {
    setMuted(!isMuted);
    audioPlayer.current.muted = !audioPlayer.current.muted;
  };

  const timeUpdate = () => {
    if (!Number.isNaN(audioPlayer.current.duration)) {
      progressBar.current.value = audioPlayer.current.currentTime / audioPlayer.current.duration;
    }
  };

  return (
    <div className="m-auto flex gap-2 table:gap-4 w-150 table:w-300 xl:w-500 h-10 bg-transparent items-center border-2 border-borderColor rounded-2xl">
      <audio
        ref={audioPlayer}
        className="audio"
        id="audio"
        src={`/Assets/Audio/${playList[currentSound]}.mp3`}
        onTimeUpdate={timeUpdate}
        onEnded={handleNextTrack}></audio>
      <div className="ml-4 flex gap-2">
        <div
          className="cursor-pointer flex justify-center items-center duration-200 player-btn"
          onClick={handlePreviousTrack}>
          <PrevIcon />
        </div>
        <div className="flex justify-center items-center cursor-pointer duration-200" onClick={togglePlay}>
          {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </div>
        <div
          className="flex justify-center items-center cursor-pointer duration-200 player-btn"
          onClick={handleNextTrack}>
          <NextIcon />
        </div>
      </div>
      <progress className="progress-bar" ref={progressBar} value="0" max="1"></progress>
      <div
        className="mr-4 flex justify-center items-center cursor-pointer duration-200 player-btn"
        onClick={handleMute}>
        {isMuted ? <VolumeIcon /> : <MuteIcon />}
      </div>
    </div>
  );
};
